import React from "react";
import { useNavigate } from "react-router-dom";

const ProviderListHeader = () => {
  const navigate = useNavigate();
  return (
    <header className="d-flex flex-column flex-md-row justify-content-between align-items-center p-2 mt-4 mb-1">
      <h5 className="fw-bold mb-2 mb-md-0 mt-5 mt-md-0">My Listings</h5>

      <div>
        <button
          style={{
            marginRight: "10px",
            cursor: "pointer",
            padding: "7px 14px",
            borderRadius: "5px",
            backgroundColor: "rgba(245, 192, 0, 0.7)",
            color: "#000",
            border: "none",
            fontWeight: "400",
          }}
          onClick={(e) => {
            e.preventDefault();
            navigate("/provider-business/new");
          }}
        >
          List Your Space
        </button>
      </div>
    </header>
  );
};

export default ProviderListHeader;
